"use strict";

var Dispatcher = require("flux").Dispatcher;

class AppDispatcher extends Dispatcher {}

module.exports = new AppDispatcher();
